import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import {
  Package,
  Zap,
  Globe,
  Award,
  FileText,
  Settings,
} from 'lucide-react';

export const ServicesGrid = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const services = [
    {
      icon: FileText,
      title: 'VTV Stationary',
      description: 'Complete range of office and school stationery supplies for all your writing and organizational needs.',
      color: 'primary',
      image: '/Services/VTV Stationery.png',
    },
    {
      icon: Package,
      title: 'VTV Fancy',
      description: 'Unique fancy items, gifts, and decorative products to add charm and elegance to any occasion.',
      color: 'accent',
      image: '/Services/VTV Fancy.png',
    },
    {
      icon: Zap,
      title: 'VTV Electronic',
      description: 'Quality electronic products and accessories with reliable performance and competitive pricing.',
      color: 'primary',
      image: '/Services/VTV Electronic.png',
    },
    {
      icon: Globe,
      title: 'VTV Travel',
      description: 'Comprehensive travel services including ticketing, tour packages, and travel consultation.',
      color: 'accent',
      image: '/Services/VTV Travel.png',
    },
    {
      icon: Award,
      title: 'VTV Education',
      description: 'Educational materials, resources, and support services to enhance learning experiences.',
      color: 'primary',
      image: '/Services/VTV Education.png',
    },
    {
      icon: Settings,
      title: 'VTV Solutions',
      description: 'Tailored business solutions designed to meet your unique requirements and drive success.',
      color: 'accent',
      image: '/Services/VTV Solutions.png',
    },
  ];

  return (
    <section ref={ref} className="py-10 sm:py-14">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20, rotateY: -10 }}
                animate={isInView ? { opacity: 1, y: 0, rotateY: 0 } : { opacity: 0, y: 20, rotateY: -10 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.05, rotateZ: 2 }}
                className="glass-card p-6 rounded-xl group cursor-pointer"
              >
                <div className="space-y-4">
                  <div className="relative w-full aspect-square rounded-lg overflow-hidden mb-4 bg-gray-50">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <h3 className="text-lg font-semibold group-hover:text-primary transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
